(function () {
  'use strict';
  function initGallery(scope) {
    scope.querySelectorAll('[data-er-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.erGalleryReady) return;
      gallery.dataset.erGalleryReady = 'true';
      var track = gallery.querySelector('[data-er-gallery-track]');
      var slides = Array.from(track.querySelectorAll('[data-er-media-id]'));
      if (!slides.length) return;
      var thumbs = Array.from(gallery.querySelectorAll('[data-er-gallery-target]'));
      var counter = gallery.querySelector('[data-er-gallery-counter]');
      var previous = gallery.querySelector('[data-er-gallery-prev]');
      var next = gallery.querySelector('[data-er-gallery-next]');
      var xr = gallery.querySelector('[data-shopify-xr]');
      var index = -1, scrollFrame = 0, resizeFrame = 0;
      var pictures = Array.from(track.querySelectorAll('.er-gallery__image'));
      function fitPicture(image) {
        if (gallery.dataset.erImageFocus === 'false' || !image.naturalWidth || !image.naturalHeight) return;
        if (image.erBounds === undefined) {
          image.erBounds = null;
          try {
            var canvas = document.createElement('canvas'), size = 128;
            canvas.width = canvas.height = size;
            var context = canvas.getContext('2d', {willReadFrequently:true});
            if (!context) return;
            context.drawImage(image, 0, 0, size, size);
            var pixels = context.getImageData(0, 0, size, size).data;
            var corners = [0, size - 1, size * (size - 1), size * size - 1];
            var transparent = corners.every(function (p) { return pixels[p * 4 + 3] < 20; });
            var white = corners.every(function (p) { return pixels[p * 4] > 240 && pixels[p * 4 + 1] > 240 && pixels[p * 4 + 2] > 240; });
            // Fit only known empty borders. Unreadable or detailed backgrounds keep their natural framing.
            if (!transparent && !white) return;
            var left = size, right = -1, top = size, bottom = -1, count = 0;
            for (var y = 0; y < size; y++) for (var x = 0; x < size; x++) {
              var p = (y * size + x) * 4;
              var solid = pixels[p + 3] > 32 && (transparent || Math.min(pixels[p], pixels[p + 1], pixels[p + 2]) < 238);
              if (!solid) continue;
              left = Math.min(left, x); right = Math.max(right, x); top = Math.min(top, y); bottom = Math.max(bottom, y); count++;
            }
            if (count < 20 || right - left < size * .2 || bottom - top < size * .2) return;
            // A generous buffer keeps pale edges and resampling outside the detected silhouette.
            var padding = size * .05;
            image.erBounds = {left:Math.max(0,left-padding)/size, right:Math.min(size,right+1+padding)/size, top:Math.max(0,top-padding)/size, bottom:Math.min(size,bottom+1+padding)/size};
          } catch (ignore) { return; }
        }
        if (!image.erBounds) return;
        var slide = image.closest('[data-er-media-id]'), width = slide.clientWidth, height = slide.clientHeight;
        if (!width || !height) return;
        var bounds = image.erBounds, base = Math.min(width/image.naturalWidth, height/image.naturalHeight);
        var scale = Math.min(1.5, width*.88/((bounds.right-bounds.left)*image.naturalWidth*base), height*.88/((bounds.bottom-bounds.top)*image.naturalHeight*base));
        if (scale <= 1.08) { image.style.transform = ''; return; }
        var dx = (.5-(bounds.left+bounds.right)/2)*image.naturalWidth*base;
        var dy = (.5-(bounds.top+bounds.bottom)/2)*image.naturalHeight*base;
        image.style.transform = 'scale('+scale.toFixed(4)+') translate('+dx.toFixed(2)+'px,'+dy.toFixed(2)+'px)';
      }
      pictures.forEach(function (image) { image.addEventListener('load', function () { fitPicture(image); }); if (image.complete) fitPicture(image); });
      function pause(slide) {
        slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
        if (window.jQuery) jQuery(slide).trigger('mediaHidden');
        slide.querySelectorAll('iframe').forEach(function (frame) {
          try {
            var url = new URL(frame.src, window.location.href);
            if (/^(www\.)?(youtube\.com|youtube-nocookie\.com)$/.test(url.hostname)) frame.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), url.origin);
            if (url.hostname === 'player.vimeo.com') frame.contentWindow.postMessage(JSON.stringify({method:'pause'}), url.origin);
          } catch (ignore) {}
        });
      }
      function activate(target) {
        target = Math.max(0, Math.min(slides.length - 1, target));
        if (index === target) return;
        if (index >= 0) pause(slides[index]);
        index = target;
        slides.forEach(function (slide, i) {
          // Photo slides must remain hit-testable while a native swipe crosses between them.
          slide.toggleAttribute('inert', slide.dataset.erMediaType !== 'image' && i !== index);
          slide.setAttribute('aria-hidden', String(i !== index));
          var zoomLink = slide.querySelector('[data-er-image-zoom]');
          if (zoomLink) zoomLink.setAttribute('tabindex', i === index ? '0' : '-1');
        });
        thumbs.forEach(function (thumb) {
          if (thumb.dataset.erGalleryTarget === slides[index].dataset.erMediaId) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        counter.textContent = (index + 1) + ' / ' + slides.length;
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        if (xr && slides[index].dataset.erMediaType === 'model') xr.setAttribute('data-shopify-model3d-id', slides[index].dataset.erMediaId);
      }
      function go(target, instant) {
        target = Math.max(0, Math.min(slides.length - 1, target));
        activate(target);
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({left:slides[target].offsetLeft - slides[0].offsetLeft, behavior:instant || reduced ? 'auto' : 'smooth'});
      }
      function byId(id, instant) {
        var target = slides.findIndex(function (slide) { return slide.dataset.erMediaId === String(id); });
        if (target >= 0) go(target, instant);
      }
      thumbs.forEach(function (thumb) { thumb.addEventListener('click', function (event) { event.preventDefault(); byId(thumb.dataset.erGalleryTarget); }); });
      if (previous) previous.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      track.addEventListener('scroll', function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = 0;
          var nearest = 0, distance = Infinity;
          slides.forEach(function (slide, i) { var d = Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft); if (d < distance) { distance = d; nearest = i; } });
          activate(nearest);
        });
      }, {passive:true});
      track.addEventListener('keydown', function (event) {
        if (event.target !== track && !event.target.closest('[data-er-image-zoom]')) return;
        var target;
        if (event.key === 'ArrowRight') target = index + 1;
        else if (event.key === 'ArrowLeft') target = index - 1;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = slides.length - 1;
        else return;
        event.preventDefault();
        go(target);
        if (event.target !== track) track.focus({preventScroll:true});
      });
      function onVariant(event) {
        var detail = event.detail || {};
        if (detail.sectionId && detail.sectionId !== gallery.dataset.erSectionId) return;
        var variant = detail.variant;
        var media = variant && (variant.featured_media || variant.featured_image);
        if (media) byId(media.id, true);
      }
      function onResize() {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(function () { resizeFrame = 0; go(index, true); pictures.forEach(fitPicture); });
      }
      document.addEventListener('erredue:variant-change', onVariant);
      window.addEventListener('resize', onResize, {passive:true});
      function onUnload(event) {
        if (!event.target.contains(gallery)) return;
        document.removeEventListener('erredue:variant-change', onVariant);
        document.removeEventListener('shopify:section:unload', onUnload);
        window.removeEventListener('resize', onResize);
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        slides.forEach(pause);
      }
      document.addEventListener('shopify:section:unload', onUnload);
      activate(0);
      byId(gallery.dataset.erInitialMedia, true);
      gallery.querySelector('[data-er-gallery-controls]').hidden = false;

      var dialog = gallery.querySelector('[data-er-image-dialog]');
      var zoomImage = dialog.querySelector('[data-er-zoom-image]');
      var zoomViewport = dialog.querySelector('[data-er-zoom-viewport]');
      var zoomToggle = dialog.querySelector('[data-er-zoom-toggle]');
      var zoomSource;
      function setZoom(zoomed) {
        zoomViewport.classList.toggle('is-zoomed', zoomed);
        zoomToggle.setAttribute('aria-pressed', String(zoomed));
        zoomToggle.textContent = zoomed ? 'Riduci' : 'Ingrandisci';
        if (!zoomed) zoomViewport.scrollTo({top:0,left:0});
      }
      gallery.querySelectorAll('[data-er-image-zoom]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          zoomSource = link;
          zoomImage.src = link.href;
          zoomImage.alt = link.closest('[data-er-media-id]').querySelector('.er-gallery__image').alt;
          setZoom(false);
          dialog.showModal();
        });
      });
      function toggleZoom() { setZoom(!zoomViewport.classList.contains('is-zoomed')); }
      zoomToggle.addEventListener('click', toggleZoom);
      zoomImage.addEventListener('click', toggleZoom);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', function () { setZoom(false); if (zoomSource && zoomSource.isConnected) zoomSource.focus({preventScroll:true}); });
    });
  }
  function init() { initGallery(document); document.addEventListener('shopify:section:load', function (event) { initGallery(event.target); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
